import Vue from "vue";
import VueAnalytics from "vue-analytics";

Vue.use(VueAnalytics, {
  id: "UA-79725464-7"
});

const ga = Vue.$ga;

/**
 *  Send event
 *
 * @param {*} category
 * @param {*} action
 * @param {*} label
 */
const event = (category, action, label) => {
  // window.console.log(category, action, label);
  // ga("send", "event", category, action, label);
  ga.event(category, action, label);
};

const pageview = path => {
  // window.console.log(path);
  return new Promise((resolve, reject) => {
    // window.console.log(ga);
    // ga("set", "page", path);
    // ga("send", "pageview");
    ga.page(path);
    resolve();
  });
};

export default {
  event,
  pageview
};
